import PartsSection from "./PartsSection";
import DesignerFinalStepSection from "./DesignerFinalStepSection";
import DesignerVariantStepSection from "./DesignerVariantStepSection";
import DesignerDetailsStepSection from "./DesignerDetailsStepSection";
import DesignerStripesStepSection from "./DesignerStripesStepSection";
import { STEP } from "./designerSteps";

const DesignerStepPanel = ({
    currentStepKey,
    variantStepProps,
    detailsStepProps,
    stripesStepProps,
    step1PartsSectionProps,
    step2PartsSectionProps,
    finalStepProps,
}) => {
    return (
        <>
            {currentStepKey === STEP.MODEL ? (
                <DesignerVariantStepSection {...variantStepProps} />
            ) : null}

            {currentStepKey === STEP.DETAILS ? (
                <DesignerDetailsStepSection {...detailsStepProps} />
            ) : null}

            {currentStepKey === STEP.PAINT ? (
                <PartsSection {...step1PartsSectionProps} />
            ) : null}

            {currentStepKey === STEP.STRIPES ? (
                <DesignerStripesStepSection {...stripesStepProps} />
            ) : null}

            {currentStepKey === STEP.PRINTS ? (
                <PartsSection {...step2PartsSectionProps} />
            ) : null}

            {currentStepKey === STEP.SUMMARY ? (
                <DesignerFinalStepSection {...finalStepProps} />
            ) : null}
        </>
    );
};

export default DesignerStepPanel;
